import { STORE_NUDGE_COPY } from '../model/constants'

export type StoreNudgeThumb = {
  id: number
  name: string
  imageUrl: string
}

export type StoreNudgeThumbStripProps = {
  thumbs: StoreNudgeThumb[]
  /** Itens visíveis que não couberam na faixa ("+N"). */
  overflow: number
  /** Itens visíveis fora dos destaques — a frase "e tem mais N". */
  othersCount: number
  onSelect: () => void
}

const TILE_CLASS =
  'flex h-14 w-14 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-lg border border-gray-200 bg-white p-0 shadow-sm transition-colors hover:bg-gray-100'

/**
 * Faixa de miniaturas do resto da vitrine. O objetivo do popup é mostrar que a
 * lojinha existe e está cheia — não vender o item em destaque.
 */
export const StoreNudgeThumbStrip = ({
  thumbs,
  overflow,
  othersCount,
  onSelect
}: StoreNudgeThumbStripProps) => {
  if (othersCount <= 0) return null

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex items-center justify-center gap-2">
        {thumbs.map(thumb => (
          <button
            key={thumb.id}
            type="button"
            onClick={onSelect}
            aria-label={`Ver ${thumb.name} na lojinha`}
            className={TILE_CLASS}
          >
            <img
              src={thumb.imageUrl}
              alt=""
              loading="lazy"
              decoding="async"
              className="h-full w-full object-cover"
            />
          </button>
        ))}
        {overflow > 0 && (
          <button
            type="button"
            onClick={onSelect}
            aria-label={`Ver mais ${overflow} itens na lojinha`}
            className={`${TILE_CLASS} text-sm font-bold text-gray-700`}
          >
            +{overflow}
          </button>
        )}
      </div>
      <p className="m-0 text-center text-sm text-gray-700">
        {STORE_NUDGE_COPY.othersCount(othersCount)}
      </p>
    </div>
  )
}

StoreNudgeThumbStrip.displayName = 'StoreNudgeThumbStrip'
